import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation('common');
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/64fdb59b2f8790dfe03636b7c4fabb1b.jpg"
          alt="Worship Service"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight">
          {t('hero.title')}
        </h1>
        <p className="text-xl md:text-2xl mb-12 text-gray-200 max-w-3xl mx-auto font-light">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <a
            href="http://www.youtube.com/@AIDWorship"
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-4 bg-amber-500 hover:bg-amber-600 text-black font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap text-base"
          >
            {t('hero.watchBtn')}
          </a>
          <button
            onClick={() => scrollToSection('contact')}
            className="px-10 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-black text-white font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap text-base"
          >
            {t('hero.joinBtn')}
          </button>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer">
        <button
          onClick={() => scrollToSection('next-generation')}
          className="text-white/70 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
}
